const DATE_COLS = new Set(['date']);

export function sortDocuments(docs, col, dir) {
	return [...docs].sort((a, b) => {
		let av = a[col] ?? '';
		let bv = b[col] ?? '';

		if (DATE_COLS.has(col)) {
			av = Date.parse(av) || 0;
			bv = Date.parse(bv) || 0;
			return dir === 'asc' ? av - bv : bv - av;
		}

		av = String(av).toLowerCase();
		bv = String(bv).toLowerCase();
		const cmp = av.localeCompare(bv, undefined, { numeric: true, sensitivity: 'base' });
		return dir === 'asc' ? cmp : -cmp;
	});
}
